import currency from 'currency.js';

export const currencyFormats = {
  COP: (v) => currency(v, { decimal: ',', separator: '.' }),
  DEFAULT: (v, s) => currency(v, { symbol: s, pattern: '# !' })
};
